module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasSpaces) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_vm._l((_vm.spaces), function(item, index) {
    return _c('SpaceCard', {
      key: item.id,
      attrs: {
        "item": item,
        "partnerId": _vm.partnerId
      }
    })
  }), (_vm.pagesCount > 1) ? _c('Paginator', {
    attrs: {
      "count": _vm.pagesCount,
      "current": _vm.page,
      "max": 6
    }
  }) : _vm._e(), _c('SelectCount', {
    attrs: {
      "slot": "right",
      "options": _vm.pageLimits,
      "value": _vm.pageLimit,
      "text": _vm.byPageText
    },
    on: {
      "change": _vm.pageLimitChange
    },
    slot: "right"
  })], 2) : _c('center', [_c('b', [_vm._v("К СОЖАЛЕНИЮ, ПО ДАННЫЙ ОРГАНИЗАТОР НЕ ДОБАВИЛ НИКАКИХ ПОМЕЩЕНИЙ.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7e8df9e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/spaces/Spaces.vue
// module id = 1b97027bd1472d38d128
// module chunks = 25